import { render, staticRenderFns } from "./com-business-table.vue?vue&type=template&id=7393271b&"
import script from "./com-business-table.vue?vue&type=script&lang=js&"
export * from "./com-business-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports